import { IApplicationState } from '../../types/redux';
import { IBreadcrumbSchema } from '../../repositories/newbuilding-card/entities/breadcrumbs/BreadcrumbSchema';

export function getBreadCrumbs(state: IApplicationState): IBreadcrumbSchema[] {
  const {
    newbuilding: { breadcrumbs },
  } = state;

  if (breadcrumbs && breadcrumbs.length) {
    return breadcrumbs;
  }

  return [];
}
